import { stationsActions } from '../reducer';

import { StationsState } from '../../types';

export const updateAddingFavouriteStationsStatus = (status?: StationsState['favouriteStations']['addingStatus']) => stationsActions
  .setAddingFavouriteStationsStatus(status);
